import { DatadogInstaller } from "./types";

export const datadogInstaller: DatadogInstaller = {
  "audit-log": {
    items: {
      endpoint: {
        labeler: () => "Intake URL",
      },
      apiKey: {
        labeler: () => "API key",
      },
      service: {},
    },
  },
};
